var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index + 2,
      staticClass: "listBox",
      class: _vm.styleObj.controlsComponentsMark == "informationConfirmation2" ? "listBox2" : ""
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "list"
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2 + 1
      }, [_c("div", {
        style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.name)) + " ")]), _c("div", {
        style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
      }, [_vm._v("xx")])]);
    }), 0)]);
  }), 0), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };